<template>
  <page-with-aside :hasFooter="true">
    <template #navheader>
      <site-header></site-header>
    </template>

    <template #content>
      <section class="content">
        <h2>Study Eligibility</h2>
        <h4>Thank you for your interest in Open to Options.</h4>

        <p>Unfortunately, you are not eligible to participate at this time. Thank you for your interest in Open to Options.</p>
      </section>
    </template>
  </page-with-aside>
</template>

<script>
import PageWithAside from "@/components/PageWithAside.vue";
import SiteHeader from "@/components/siteHeader.vue";

export default {
  name: "Ineligible",

  components: {
    "site-header": SiteHeader,
    PageWithAside
  }
};
</script>